<template>
    <div class="row">
        <div class="col-md-12">
            <div class="box box-primary">
                <div class="overlay" v-if="loading">
                    <i class="fa fa-refresh fa-spin"></i>
                </div>
                <div class="box-header with-border">
                    <h3 class="box-title">Vérification des compétiteurs</h3>
                </div>
                <div class="box-body">
                    <p>
                        Choisissez le fichier XML fourni par Martial Events et cliquer sur "Envoyer" pour recevoir le compte-rendu sous format Excel
                    </p>
                    <hr>
                    <form>
                        <input type="file"
                               id="file"
                               ref="fileInput"
                               name="file"
                               class="m-3">

<!--                        <input type="submit" @click.prevent="exportMartialEventsVerification()" value="Envoyer">-->
                        <b-btn title="Envoyer"
                               type="submit"
                               @click.prevent="exportMartialEventsVerification()"
                               class="btn btn-primary " style="margin-top: 10px;">
                            Envoyer
                        </b-btn>
                    </form>
                </div>
            </div>
        </div>

    </div>
</template>


<script>
    import {mapGetters, mapActions} from 'vuex'

    var moment = require('moment')
    var FileSaver = require('file-saver');

    export default {
        data() {
            return {
                file: null,
                loading: false,
            }
        },
        props: {},
        computed: {
            ...mapGetters({
                getRoute: 'getRoute',
            }),
        },
        mounted: function () {
        },
        methods: {
            ...mapActions({}),

            exportMartialEventsVerification: function () {
                let file = this.$refs.fileInput.files[0];
                let formData = new FormData();
                formData.append('file', file);
                // console.log(file);
                let self = this;
                this.loading = true
                this.$http.post(this.getRoute('Secretariat.exportMartialEventsVerification'), formData, {responseType: 'blob'})
                    .then(function (response) {
                        var blob = new Blob([response.body], {type: 'application/vnd.ms-excel'});
                        FileSaver.saveAs(blob, "exportMartialEventsVerification.xlsx");
                        self.loading = false;
                        return response.blob();
                    }, (response) => {
                        self.$noty.error("Erreur dans la génération de l'export")
                        self.loading = false;
                    });
            },

        },
        beforeRouteUpdate(to, from, next) {
        },

        beforeRouteEnter(to, from, next) {
        },
        watch: {},
        components: {}
    }
</script>


// WEBPACK FOOTER //
// src/components/Secretariat/Verification/Martial_Events.vue